<template>
  <v-app>
    <header-page></header-page>
    <body-page></body-page>
    <footer-page></footer-page>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import HeaderPageComponent from './components/HeaderPageComponent.vue';
import BodyPageComponent from './components/BodyPageComponent.vue';
import FooterPageComponent from './components/FooterComponent.vue';
export default {
  name: 'App',

  components:{
    'header-page':HeaderPageComponent,
    'body-page':BodyPageComponent,
    'footer-page':FooterPageComponent,
  },
  data: () => ({
    
  }),
  methods:{
    
  }
};
</script>
<style scoped>
  .active_lg{
    border:1px solid black;
  }
</style>
